/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import { combineReducers } from 'redux';
import { SagaIterator } from 'redux-saga';
import { call, put, race, select, takeLatest } from 'redux-saga/effects';
import {
  ActionCreators as ContextActionCreators,
  FolderInfoContext,
  ParentContext,
  takeFolderCtx,
  InitContext,
  ActionType,
} from './context';

import * as CurrentFolder from './currentFolder';
import * as Rails from './rails';
import * as Options from './options';
import * as RunOption from './runOption';

export type { FolderInfoContext, ParentContext };

export const ActionCreators = {
  ...ContextActionCreators,
  rails: Rails.ActionCreators,
  options: Options.ActionCreators,
  runOption: RunOption.Creators,
};

export default combineReducers({
  folder: CurrentFolder.default,
  rails: Rails.default,
  options: Options.default,
  runOption: RunOption.default,
});

export const Selectors = {
  folder: CurrentFolder.Selectors,
  rails: Rails.Selectors,
  options: Options.Selectors,
  runOption: RunOption.Selectors,
};

function* init(action: InitContext): SagaIterator {
  const { ctx, parentCtx, channelId } = action.meta;
  yield put(ActionCreators.runOption.init());

  if (!ctx.entryAsset) {
    yield put(CurrentFolder.ActionCreators.init(ctx));

    const [, error] = yield race([
      takeFolderCtx(CurrentFolder.ActionType.SUCCESS, ctx),
      takeFolderCtx(CurrentFolder.ActionType.ERROR, ctx),
    ]);

    if (error) {
      return;
    }

    ctx.entryAsset = yield select(Selectors.folder.getAsset, ctx);
  }

  yield put(Rails.ActionCreators.init(ctx, parentCtx, channelId));
}

export const sagas = [
  takeLatest(ActionType.INIT, init),
  call(CurrentFolder.sagas),
  call(Rails.sagas),
  call(Options.sagas),
  call(RunOption.saga),
];
